import React, { useState, useEffect } from "react";
import { Container, Navbar, Dropdown, Modal, Button, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Icons
import { FaBars, FaLock, FaLockOpen } from "react-icons/fa"; // Aggiunte icone lock

// Immagini (assumendo siano correttamente importate)
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png"; 
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";
import logoInvert3 from "../images/TP-_logo-symbol-white.png";

function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    // Se è "true" (stringa), il ricaricamento è BLOCCATO. 
    return lockedState ? JSON.parse(lockedState) : false;
  });
  
  const [downloads, setDownloads] = useState([]);

  // Funzione per switchare il blocco
  const toggleLock = () => {
    setIsLocked(!isLocked);
  };

  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));
    
    let intervalId;

    if (isLocked) {
      // SE BLOCCATO: Non facciamo nulla o puliamo eventuali timer esistenti
      console.log("Ricaricamento automatico disattivato");
    } else {
      // SE NON BLOCCATO: La pagina si ricarica ogni 150 secondi
      intervalId = setInterval(() => {
        window.location.reload();
      }, 150000);
    }

    return () => clearInterval(intervalId);
  }, [isLocked]);

  useEffect(() => {
    fetch("mancata_vendita_dashboard.json")
      .then((res) => res.json())
      .then((data) => { if (data?.TP?.download) setDownloads(data.TP.download); })
      .catch((err) => console.error(err));
  }, []);

  return (
    <Navbar
      expand="lg"
      className="ombra-dark m-3 mb-0 mt-2 px-4 py-2 border-0 custom-red-nav"
      style={{ 
        backgroundColor: "#000000 !important", 
        borderRadius: "50px", 
        minHeight: "60px" 
      }}
    >
      <Container fluid className="p-0">
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src={logo} alt="Logo" style={{ height: "30px", width: "auto" }} />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-responsive" className="border-0 shadow-none">
          <FaBars style={{ color: "white" }} />
        </Navbar.Toggle>

        <Navbar.Collapse id="navbar-responsive" className="justify-content-between">
          <div className="d-flex flex-column flex-lg-row align-items-lg-center mt-3 mt-lg-0">
            <div className="d-flex flex-wrap align-items-center gap-3 ms-lg-4">
              <Link to="/technoparts" className="nav-link-white text-decoration-none">
                <img src={logoInvert3} alt="" className="brand-icon-white" /> TECHNOPARTS
              </Link>
              <Link to="/sud-ricambi" className="nav-link-white text-decoration-none">
                <img src={logoInvert} alt="" className="brand-icon-white" /> SUD RICAMBI
              </Link>
              <Link to="/amotive" className="nav-link-white text-decoration-none">
                <img src={logoInvert2} alt="" className="brand-icon-white" /> AMOTIVE
              </Link>
            </div>
          </div>

          {/* PARTE DESTRA: TASTO BLOCCO */}
          <div className="d-flex align-items-center gap-2 mt-3 mt-lg-0">
            <div className="v-separator-white d-none d-lg-block"></div>
            <button 
              onClick={toggleLock}
              className={`action-btn-glass circle-btn ${isLocked ? 'btn-locked-active' : ''}`}
              title={isLocked ? "Sblocca ricaricamento" : "Blocca ricaricamento"}
            >
              {isLocked ? <FaLock size={14} /> : <FaLockOpen size={14} />}
            </button>
            <span style={{ color: 'white', fontSize: '0.6rem', fontWeight: '700' }}>
              {isLocked ? "AUTO-REFRESH OFF" : "AUTO-REFRESH ON"}
            </span>
          </div>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .custom-red-nav { background-color: rgb(0, 0, 0) !important; }
        .nav-link-white {
          color: rgba(255,255,255,0.9) !important;
          font-size: 0.75rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          transition: 0.2s;
        }
        .nav-link-white:hover { color: #fff !important; transform: translateY(-1px); }
        .brand-icon-white { width: 20px; height: 20px; margin-right: 8px; filter: brightness(0) invert(1); }
        
        .action-btn-glass {
          background: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.1);
          width: 36px;
          height: 36px;
          border-radius: 50%;
          color: white !important;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .action-btn-glass:hover { background: rgba(255, 255, 255, 0.25); transform: scale(1.1); }

        .btn-locked-active {
            background: #ffc107 !important; /* Colore giallo/ambra per indicare il blocco */
            color: #000 !important;
            border-color: #fff;
        }

        .v-separator-white { width: 1px; height: 20px; background: rgba(255,255,255,0.3); margin: 0 10px; }
        .ombra-dark { box-shadow: 0 4px 20px rgba(0,0,0,0.3); }
      `}</style>
    </Navbar>
  );
}

export default BasicExample;